import styles from "./MyProducts.module.scss";
import { Accordion } from "@/pages/MainPage/ui/MyProducts/ui/Accordion/Accordion";

export const MyProducts = () => {
    return (
        <section className={styles.myProduct}>
            <div className={styles.title}>my products</div>
            <Accordion />
        </section>
    );
};
